var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Popover",
    {
      attrs: {
        target: _vm.popoverTarget,
        trigger: "manual",
        placement: "bottom",
        "custom-class": "saved-report-popover"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.label
        ? _c(
            "btn",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.tooltip,
                  expression: "tooltip",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              ref: "labelButton",
              staticClass: "m-l-10",
              attrs: {
                "native-type": "submit",
                size: "sm",
                type: _vm.type,
                disabled: _vm.disabled
              },
              on: { click: _vm.onClick }
            },
            [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.label
        ? _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom.hover",
                value: _vm.tooltip,
                expression: "tooltip",
                modifiers: { bottom: true, hover: true }
              }
            ],
            ref: "icon",
            staticClass: "btn btn-function f-s-16 m-l-10",
            class: _vm.iconClass,
            attrs: { type: _vm.type, disabled: _vm.disabled },
            on: { click: _vm.onClick }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("template", { slot: "popover" }, [
        _c(
          "div",
          { staticClass: "clearfix" },
          [
            _c("form", [
              _c(
                "div",
                { staticClass: "m-b-25" },
                [
                  _c("label", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "VISIBILITY",
                        expression: "'VISIBILITY'"
                      }
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "btn-group",
                    { attrs: { justified: "" } },
                    [
                      _c(
                        "btn",
                        {
                          attrs: {
                            "input-type": "radio",
                            "input-value": "personal",
                            type: "primary",
                            justified: ""
                          },
                          model: {
                            value: _vm.visibility,
                            callback: function($$v) {
                              _vm.visibility = $$v
                            },
                            expression: "visibility"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("PERSONAL")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "btn",
                        {
                          attrs: {
                            "input-type": "radio",
                            "input-value": "shared",
                            type: "primary",
                            justified: ""
                          },
                          model: {
                            value: _vm.visibility,
                            callback: function($$v) {
                              _vm.visibility = $$v
                            },
                            expression: "visibility"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("SHARED")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("btn", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CANCEL",
                  expression: "'CANCEL'"
                }
              ],
              staticClass: "pull-left",
              attrs: { type: "default", size: "sm" },
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            }),
            _vm._v(" "),
            _c("btn", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "SAVE",
                  expression: "'SAVE'"
                }
              ],
              staticClass: "pull-right",
              attrs: { type: "primary", size: "sm", disabled: _vm.disabled },
              on: {
                click: function($event) {
                  return _vm.$emit("onSaveReport", _vm.visibility === "shared")
                }
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }